import { jsx as l } from "react/jsx-runtime";
const d = (e) => /* @__PURE__ */ l(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    ...e,
    children: /* @__PURE__ */ l(
      "path",
      {
        fill: "#3DDC84",
        fillRule: "evenodd",
        d: "M5.577 6.426a.7.7 0 0 1 .957.256l1.534 2.659A10.3 10.3 0 0 1 12 8.576c1.413 0 2.744.274 3.947.771l1.535-2.659a.7.7 0 1 1 1.213.7l-1.492 2.585c2.693 1.59 4.521 4.398 4.797 7.695H2c.276-3.303 2.11-6.115 4.812-7.704l-1.49-2.582a.7.7 0 0 1 .255-.956m11.026 8.392a.834.834 0 0 1 0-1.665.834.834 0 0 1 0 1.665m-9.206 0a.834.834 0 0 1 0-1.665.834.834 0 0 1 0 1.665",
        clipRule: "evenodd"
      }
    )
  }
);
export {
  d as default
};
